import { useGetStationDisplayName } from "@/entities/station";
import { Button } from "@/shared/components";

interface StationHeaderProps {
    stationCode: string;
    children?: React.ReactNode;
}

export function StationHeader({ stationCode, children }: Readonly<StationHeaderProps>) {
    const getStationDisplayName = useGetStationDisplayName("stationCodeSuffixed");

    return (
        <div className="flex items-center justify-between" data-testid={`faciliteiten-station-header-${stationCode}`}>
            <h3 className="text-content-default text-lg font-semibold">{getStationDisplayName(stationCode)}</h3>
            {children}
        </div>
    );
}

interface SelectAllActionsProps {
    onSelectAll: () => void;
    onDeselectAll: () => void;
}

export function SelectAllActions({ onSelectAll, onDeselectAll }: Readonly<SelectAllActionsProps>) {
    return (
        <div className="flex gap-2">
            <Button variant="tertiary" size="s" onClick={onSelectAll}>
                Alles selecteren
            </Button>
            <Button variant="tertiary" size="s" onClick={onDeselectAll}>
                Alles deselecteren
            </Button>
        </div>
    );
}

interface SmartSelectAllButtonProps {
    allSelected: boolean;
    hasSelectableItems: boolean;
    onToggleSelectAll: () => void;
}

export function SmartSelectAllButton({ allSelected, hasSelectableItems, onToggleSelectAll }: Readonly<SmartSelectAllButtonProps>) {
    if (!hasSelectableItems) return null;

    return (
        <Button
            variant="tertiary"
            size="s"
            onClick={onToggleSelectAll}
            className="text-content-interactive-default hover:text-content-interactive-hover h-auto font-normal hover:bg-transparent"
        >
            {allSelected ? "Deselecteer alles" : "Selecteer alles"}
        </Button>
    );
}
